import {
    GodrejConfig,
    ReloyConfig,
    MahindraConfig,
    EmbassyConfig,
    SpreConfig,
    KrcConfig,
    JpwowConfig,
    M3MConfig,
    KeeClubConfig,
    metroConfig,
    SushmaConfig,
    HeoConfig,
    PurtiConfig,
    MaxConfig,
    NamanConfig,
    AjmeraConfig,
    BPTPConfig,
    SmartWorldCareConfig,
    BirlaConfig,
    MayfairConfig,
    AlohaConfig,
    RajatConfig,
    ChandakConfig,
    OmSreeConfig,
    EdenConfig,
    PrimarcConfig,
    RrinfraConfig,
    DefaultConfig,
    AsharConfig
} from '../db/Configurations';
import store from '../store'; // Adjust path based on your project structure

const clientId = window.reloy_env.CLIENT_ID;
const isWebFormOnly = window.reloy_env.WEBFORM_ONLY;
const tenantShortId = (window.reloy_env.allTenants || []).find(
    (t) => t.clientId == clientId
)?.id;

// Get the current state
const state = store.getState();

// Access a specific slice of the state
const clientWebview = state.webView.clientWebview;
const internalWebview = state.webView.internalWebview;

const getConfigInternal = () => {
    switch (clientId) {
        case '43f9ae0bd0e04f52e4d95b93bcf34138dbf6052b78dc2710ff4eb90b3c69f096':
            return ReloyConfig;
        case '89dcfa41903ebba52c0b371d5dcdddb67e8bfd8daf8fea6019ada584de2af9ca':
            return KrcConfig;
        case '4757d92ecbc85bd93320870e1d15ae79788920c0cbf41abe884bfbc4980a0c08':
            return GodrejConfig;
        case '89f7c75cc7d56d4969a90431f3aa0bf6dff0f21e8656455ae0068483f578584a':
            return MahindraConfig;
        case '576105b5b11f0894b219ccfbadece57ae637db4513eaee8c1c12436438925fed':
            return EmbassyConfig;
        case 'b170c980898c1639711e4613010044c8bfa37f205d1c599e54660417645e9c8b':
            return SpreConfig;
        case '51808609e781b8dd8ba561acf88914887185adba2fe5a2698192e9d19d24dc53':
            return JpwowConfig;
        case '519cccdf78f4f5a1f65ea6831f6eca84f48983b90c999e50d91fbe92247e82ea':
            return M3MConfig;
        case '975fa9cb66b0d5d89cea9e33ecfa3a7438d368695e6addce57816a13c4b4e570':
            return KeeClubConfig;
        case 'dc024884e6e4b9419ef464014a0bfd3254d272e71b5bb68eed21b4f563e27170':
            return metroConfig;
        case 'fbbc10bec56bdff797eebe2fa934a435fdbe2b511526d66cfbdee767d90dfb96':
            return SushmaConfig;
        case '1ae3e252ad3b470f185954ae0f5c4375f7b26a6751da701445648b5bfe638d3c':
            return HeoConfig;
        case '6b6e22e7059b0914d97659142af96bd203db6edf2f8337f468912ae2f4ad9098':
            return PurtiConfig;
        case '98a4ea4028d47686c954d430b36af8aa288eccdfc8a9e28afcd1a266ec01252f':
            return MaxConfig;
        case 'fd7f9ec0d5ad805adc07b227e9de4b32e03380334c387f3c569b4c4198bc1e46':
            return NamanConfig;
        case '1879e2bd97969b10daee96c287081c6d01828015f28a06b0eccc08b348e3ea89':
            return AjmeraConfig;
        case '9821d132cf75037b0b77441d54485292112cd9de652b67431187cf324596d6f7':
            return BPTPConfig;
        case '03684311049f5cd78c9b0d8a932d4ea6e10af7e6f3ded89a860462321670b8bd':
            return SmartWorldCareConfig;
        case '707fc887817bec30baa040d88710a6989a8ae9f9ed9c115bedcdd710f0ec7d56':
            return BirlaConfig;
        case '29er65cb76f499014d6585d35a253fa1d6a96se39drq63701af8c8fe9d2458ee':
            return MayfairConfig;
        case '239c65cb76f499014d6585d35a253fa1d6a967239b6953701af8c8fe9d24c526':
            return AlohaConfig;
        case 'de0306d031a7256951ef79af23f60e1363b1a2ff3665a828c0fad33239b964c4':
            return RajatConfig;
        case 'f29f4282be0c8a96ebbf01c423292eef62d963a978d571a64ac9b017d30ad0f9':
            return ChandakConfig;
        case 'cc645dd19374b46897006c51b38df296025d3afda7ee0951c88a049845dae142':
            return OmSreeConfig;
        case '9a5a10777315248202e7c6f8d719e0d82482ec87e7b54d332db11895520e92f9':
            return EdenConfig;
        case 'af433f6a27e39daee8803009aee9524abb7d4a57a921298b29e69d47ce1aefc8':
            return PrimarcConfig;
        case '66f7d67dabe18b57f3189800307f3da2107cf870b3b9f0ebe9b43e9b75a2daa8':
            return RrinfraConfig;
        case '48999a82ce0a3ea0a08e23b5e495b8bd6b8e8189e99bdd6563bd9700cada9b2a':
            return DefaultConfig;
        case '33e9719898f659574d1e5008b09393501198d8c998f849b7783de669c80d41a9':
            return AsharConfig;
        default:
            return DefaultConfig;
    }
};

export const getConfig = () => {
    if (window.self !== window.top && !clientWebview && !internalWebview) {
        // !client wbeview !internal webview
        console.log(
            'Get config ->',
            store.getState().webView.iframeConfig?.THEME
        );
        console.log('PREVIEW CONFIG');

        return (
            store.getState().webView.iframeConfig?.THEME ||
            window.reloy_env?.client_config?.THEME
        );
    } else if (window.reloy_env?.client_config?.THEME) {
        // console.log("DASHBARD CONFIG")
        const configs = window.reloy_env?.client_config?.THEME;
        // console.log(configs);
        return {
            ...configs,
            routes: {
                ...configs.routes,
                home: getConfigInternal()?.routes?.home
            },
            id: configs?.id
        };
        // return reloyConfig;
    } else {
        console.log('CODEBASE CONFIG');
        return { ...getConfigInternal(), id: tenantShortId };
    }
};

export const routePathMap = {
    DEALS: '/deals',
    EVENTS: '/events',
    BLOGS: '/blogs',
    PROJECTS: '/projects',
    REFERRAL: '/gift-and-earn',
    CONTACT_US: '/contact-us',
    TERMS: '/terms-and-conditions',
    HOME: '/',
    REWARDS: '/rewardStore',
    BUNDLEDEALS: '/bundle-deals',
    CURATEDDEALS: '/curatedDeals',
    RENTAL: '/rentals'
};
